console.log("image-modal loaded");

// Add this function to check for touch devices
function isTouchDevice() {
  return window.matchMedia("(hover: none)").matches;
}

// Add this function to set up click handlers
function setupImageZoom() {
  const productImages = document.querySelectorAll(".product-page-image");

  productImages.forEach((image) => {
    // Only add click handlers on non-touch devices
    if (!isTouchDevice()) {
      image.addEventListener("click", function () {
        openModal(this);
      });
      image.style.cursor = "zoom-in";
    }
  });
}

function openModal(imageElement) {
  // Only proceed if not a touch device
  if (isTouchDevice()) return;

  var modal = document.getElementById("image-expand");
  var modalImg = document.getElementById("modalImage");
  var closeIcon = document.querySelector(".IMAGE_MODAL_CL_CLOSE");
  var productImage = document.querySelector(".product-page-image");

  modalImg.src = imageElement.src;
  productImage.style.cursor = "zoom-out";
  modal.style.display = "flex";
  closeIcon.style.display = "block";
  modal.scrollTop = 0;
  modal.scrollLeft = (modal.scrollWidth - modal.clientWidth) / 0;
}

function closeModal() {
  // Only proceed if not a touch device
  if (isTouchDevice()) return;

  var modal = document.getElementById("image-expand");
  var closeIcon = document.querySelector(".IMAGE_MODAL_CL_CLOSE");
  var productImage = document.querySelector(".product-page-image");

  modal.style.display = "none";
  closeIcon.style.display = "none";
  productImage.style.cursor = "zoom-in";
}

// Initialize zoom functionality when DOM is loaded
document.addEventListener("DOMContentLoaded", setupImageZoom);
